import type { FC } from 'react';
import { useEffect } from 'react';
import { loadCouponGameBlocksV2, loadSportFavoritesV2Request, loadSportsRequest, loadSportWsSettings, selectUserCurrency, selectUserIsAuthenticated } from '@mwl/core-lib';

// import { useIsSportHistoryPage } from '@/hooks';
import { useMediaWidthDown, useTypedDispatch, useTypedSelector } from '@/hooks';
import { Meta } from '../Meta/Meta';
import { SportCoupon } from './components/SportCoupon/SportCoupon';
import { SportGamesBlock } from './components/SportGamesBlock/SportGamesBlock';
import { SportSidebar } from './components/SportSidebar/SportSidebar';
import { SportToolbar } from './components/SportToolbar/SportToolbar';
import { useSportMeta } from './SportLayout.hooks';
import type { SportLayoutProps } from './SportLayout.types';
import styles from './SportLayout.module.scss';
const SportLayout: FC<SportLayoutProps> = ({
  children,
  hideToolbar,
  hideCoupon,
  hideSportSidebar,
  hideToolbarFilters,
  hideAdditionalToolbarFilters
}) => {
  const sportMeta = useSportMeta();
  const dispatch = useTypedDispatch();
  const isSmallScreen = useMediaWidthDown('screen850');
  // const isSportHistoryPage = useIsSportHistoryPage();

  const currency = useTypedSelector(selectUserCurrency);
  const isAuth = useTypedSelector(selectUserIsAuthenticated);
  useEffect(() => {
    if (currency) {
      dispatch(loadSportsRequest());
      dispatch(loadSportWsSettings());
    }
  }, [currency, dispatch]);
  useEffect(() => {
    if (currency && !isSmallScreen) {
      dispatch(loadCouponGameBlocksV2({
        size: 8
      }));
    }
  }, [currency, dispatch, isSmallScreen]);
  useEffect(() => {
    if (isAuth && currency) {
      dispatch(loadSportFavoritesV2Request());
    }
  }, [currency, dispatch, isAuth]);
  return <div className={cn(styles.root, {
    [styles.hideCoupon]: hideCoupon,
    [styles.hideSportSidebar]: hideSportSidebar
    // [styles.notSportHistory]: !isSportHistoryPage,
  })} data-sentry-component="SportLayout" data-sentry-source-file="SportLayout.tsx">
      <Meta title={sportMeta?.title} description={sportMeta?.description} metaVariables={sportMeta?.metaVariables} data-sentry-element="Meta" data-sentry-source-file="SportLayout.tsx" />
      {!hideSportSidebar && <SportSidebar className={styles.sidebarColumn} />}
      <div className={styles.main}>
        <div className={styles.content}>
          {!hideToolbar && <SportToolbar hideAdditionalToolbarFilters={hideAdditionalToolbarFilters} hideToolbarFilters={hideToolbarFilters} />}

          {children}
        </div>
      </div>
      {!hideCoupon && <div className={styles.couponColumn}>
          <SportCoupon isMobileView={isSmallScreen} />
          <SportGamesBlock productType="casino" />
          <SportGamesBlock productType="live_casino" />
        </div>}
    </div>;
};
export { SportLayout };